import Mobile from './mobile';
import Storefront from './storefront';

export default {
  Mobile,
  Storefront,
};
